import React from 'react'
import "./Spinner.css"

const Spinner = () => {
  return (
    <div className="center-body">
          <div className="loader-circle-11">
          <div className="arc"></div>
          <div className="arc"></div>
          <div className="arc"></div>
     </div>
</div>
  )
}

export default Spinner
